var fowtr_module_chapter_3 = (function (fowtr_module_chapter_3) {

    fowtr_module_chapter_3.init = function(chapter){
      
      if(fowtr_module_chapter_3.controller){
        // console.log('destroying fowtr_module_chapter_3.controller');
        fowtr_module_chapter_3.controller.destroy(true);
        fowtr_module_chapter_3.controller = null;
      }
      // gsap.killTweensOf("*");
      gsap.globalTimeline.clear();

      // console.log('fowtr_module_chapter_3 initialised');

      if(!fowtr_module_utilities.disableFancyStuff) {
        $("#fowtr-chapter3 #fowtr-article1 .fowtr-parallax-bg video").prop('muted', true);
        $("#fowtr-chapter3 #fowtr-article1 .fowtr-parallax-bg video").get(0).play();
      }




      // Video
      var mainVideo = $('#fowtr-chapter3 #fowtr-article1 video');
      // var baseSrc = 'https://dhl-future-of-work-trend-report.fra1.cdn.digitaloceanspaces.com/video/';
      mainVideo.removeAttr('src');
      var baseSrc = mainVideo.attr('data-base-ref') + 'chapter-3-cover-video-';
      if($(window).width() > 1000) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1280x720.mp4' />");
      } else if($(window).width() > 700) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1280x720.mp4' />");
      } else if($(window).width() > 400) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1280x720.mp4' />");
      } else if($(window).width() > 300) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"852x480.mp4' />");
      } else {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"352x240.mp4' />");
      }




      // PARALLAX CONTROLLER
      // duration is 300% - meaning, if will 'do stuff' for 300% of the height - and as they are 100% height, that covers them 'coming in', 'in', and 'going out' of viewport

      fowtr_module_chapter_3.controller = new ScrollMagic.Controller({
        globalSceneOptions: {
          // triggerHook: "onEnter",
          // duration: "300%"
        }});

      if(fowtr_module_utilities.disableFancyStuff) fowtr_module_chapter_3.controller = null;

      // ------------------------------------------------------------------------------------------------------
      // article 1
      // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter3 #fowtr-article1 .fowtr-parallax-bg').css({'top':'auto','bottom':'0','height':'110%',});
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article2", duration: "100%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter3 #fowtr-article1 > .fowtr-parallax-bg", {y: "50%", opacity:0, ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_3.controller);








      // // ------------------------------------------------------------------------------------------------------
      // // article 2
      // // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter3 #fowtr-article2 .fowtr-parallax-bg').css({
      //   'height':'120%',
      //   'top':'-34%',
      // });
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article2", duration: "200%", triggerHook: "onEnter"})
      //         .setTween("#fowtr-chapter3 #fowtr-article2 > .fowtr-parallax-bg", {y: "60%", ease: Linear.easeNone})
      //         .addTo(fowtr_module_chapter_3.controller);







      // ------------------------------------------------------------------------------------------------------
      // article 5 - pinning
      // ------------------------------------------------------------------------------------------------------


      // pinning the section
      var article6scene1 = new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article5", triggerHook:'onLeave'})
              .setPin("#fowtr-chapter3 #fowtr-article5")
              .on('update', function () {
                // ugly hack to detect if its full header, minimal header, fullscreen etc.
                if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')) {
                  article6scene1.offset(0);
                } else {
                  if($(window).width()<768){
                    article6scene1.offset(-56);
                  } else {
                    article6scene1.offset(-108);
                  }
                }
              })
              .addTo(fowtr_module_chapter_3.controller);

      // animating the cards, first one enlarging
      var tl = new TimelineMax();

      // var pinnedMarginTop = 120; // without secondary nav
      var pinnedMarginTop = 60; // without secondary nav
      // var pinnedMarginTop = 170; // without secondary nav
      
      article6scene1.offset(-108);

      // tl.call(function() { if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')) article6scene1.offset(0); }, null, null, 0.1);


      tl.call(function() { $('#fowtr-chapter3 #fowtr-article5').removeClass("pinned"); }, null, null, 0);
      tl.call(function() { $('#fowtr-chapter3 #fowtr-article5').removeClass("pinned"); }, null, null, 0);
      tl.to("#fowtr-chapter3 #fowtr-article5 img", 0.5, {opacity:0, ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter3 #fowtr-article5 img", 0.5, {height:0, display:'none', ease: Linear.easeNone}, 0.5);
      tl.to("#fowtr-chapter3 #fowtr-article5 h4", 1, {marginBottom:15, marginTop:pinnedMarginTop, padding:0, ease: Linear.easeNone}, 0);
      tl.fromTo("#fowtr-chapter3 #fowtr-article5 .card1 .indicator", 1, {borderBottomWidth:"0px"},{borderBottomWidth:"10px", ease: Linear.easeNone}, 0);
      // tl.fromTo("#fowtr-chapter3 #fowtr-article5 h4", 1, {fontSize:"150%"},{fontSize:"120%", ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter3 #fowtr-article5 .card1 h4, #fowtr-chapter3 #fowtr-article5 a.card1", 1, {color:'#ffcc00', ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter3 #fowtr-article5 img", 1, {marginBottom:0, ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter3 #fowtr-article5 .card1 .fowtr-black-overlay", 1, {opacity:0.7, ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter3 #fowtr-article5 .card2 .fowtr-black-overlay, #fowtr-chapter3 #fowtr-article5 .card3 .fowtr-black-overlay", 1, {opacity:0.9, ease: Linear.easeNone}, 0);
      tl.call(function() { $('#fowtr-chapter3 #fowtr-article5').addClass("pinned"); }, null, null, 2);

      // tl.call(function() { console.log('pinning article 6'); }, null, null, 0);


      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article5", triggerHook:'onLeave', duration: 300})
        // .setClassToggle("#fowtr-chapter3 #fowtr-article5", "pinned")
        .setTween(tl)
        .addTo(fowtr_module_chapter_3.controller);



      // animating the cards, second one enlarging


      var tl2 = new TimelineMax();

      tl2.to("#fowtr-chapter3 #fowtr-article5 .card1 h4, #fowtr-chapter3 #fowtr-article5 .card3 h4, #fowtr-chapter3 #fowtr-article5 a.card1, #fowtr-chapter3 #fowtr-article5 a.card3", 1, {color:'#ffffff', ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter3 #fowtr-article5 .card2 h4, #fowtr-chapter3 #fowtr-article5 a.card2", 1, {color:'#ffcc00', ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter3 #fowtr-article5 .card1 .indicator, #fowtr-chapter3 #fowtr-article5 .card3 .indicator", 1, {borderBottomWidth:"0px", ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter3 #fowtr-article5 .card2 .indicator", 1, {borderBottomWidth:"10px", ease: Linear.easeNone}, 0);

      tl2.to("#fowtr-chapter3 #fowtr-article5 .card1 .fowtr-black-overlay, #fowtr-chapter3 #fowtr-article5 .card3 .fowtr-black-overlay", 1, {opacity:0.9, ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter3 #fowtr-article5 .card2 .fowtr-black-overlay", 1, {opacity:0.7, ease: Linear.easeNone}, 0);


      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article9", duration: 300})
        .setTween(tl2)
        .addTo(fowtr_module_chapter_3.controller);



      // animating the cards, third one enlarging

      var tl3 = new TimelineMax();

      tl3.to("#fowtr-chapter3 #fowtr-article5 .card1 h4, #fowtr-chapter3 #fowtr-article5 .card2 h4, #fowtr-chapter3 #fowtr-article5 a.card1, #fowtr-chapter3 #fowtr-article5 a.card2", 1, {color:'#ffffff', ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter3 #fowtr-article5 .card3 h4, #fowtr-chapter3 #fowtr-article5 a.card3", 1, {color:'#ffcc00', ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter3 #fowtr-article5 .card1 .indicator, #fowtr-chapter3 #fowtr-article5 .card2 .indicator", 1, {borderBottomWidth:"0px", ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter3 #fowtr-article5 .card3 .indicator", 1, {borderBottomWidth:"10px", ease: Linear.easeNone}, 0);

      tl3.to("#fowtr-chapter3 #fowtr-article5 .card1 .fowtr-black-overlay, #fowtr-chapter3 #fowtr-article5 .card2 .fowtr-black-overlay", 1, {opacity:0.9, ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter3 #fowtr-article5 .card3 .fowtr-black-overlay", 1, {opacity:0.7, ease: Linear.easeNone}, 0);

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article12", duration: 300})
        .setTween(tl3)
        .addTo(fowtr_module_chapter_3.controller);



      // animating the cards, ending, fadeout

      var tl4 = new TimelineMax();

      tl4.to("#fowtr-chapter3 #fowtr-article5", 1, {autoAlpha:0, display:'none', ease: Power2.easeInOut}, 0);

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article15", duration: 300})
        .setTween(tl4)
        .addTo(fowtr_module_chapter_3.controller);










      // ------------------------------------------------------------------------------------------------------
      // article 7
      // ------------------------------------------------------------------------------------------------------

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article7", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter3 #fowtr-article7 > .fowtr-parallax-bg", {y: "60%", opacity:0, ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_3.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 8
      // ------------------------------------------------------------------------------------------------------

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article8", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter3 #fowtr-article8 > .fowtr-parallax-bg", {y: "60%", opacity:0, ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_3.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 10
      // ------------------------------------------------------------------------------------------------------

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article10", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter3 #fowtr-article10 > .fowtr-parallax-bg", {y: "60%", opacity:0, ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_3.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 11
      // ------------------------------------------------------------------------------------------------------

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article11", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter3 #fowtr-article11 > .fowtr-parallax-bg", {y: "60%", opacity:0, ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_3.controller);


      // ====================================================================
      // article 13 - six segments
      // ====================================================================


      if(!fowtr_module_utilities.isMobile){
        $('#fowtr-chapter3 #fowtr-article14 .chart-selector .selector1').data('powertip', 'Warehousing Operations').powerTip();
        $('#fowtr-chapter3 #fowtr-article14 .chart-selector .selector2').data('powertip', 'Long-Haul Transportation').powerTip();
        $('#fowtr-chapter3 #fowtr-article14 .chart-selector .selector3').data('powertip', 'Last-Mile Delivery').powerTip();
        $('#fowtr-chapter3 #fowtr-article14 .chart-selector .selector4').data('powertip', 'Back-Office Operations').powerTip();
        $('#fowtr-chapter3 #fowtr-article14 .chart-selector .selector5').data('powertip', 'Customer Service').powerTip();
        $('#fowtr-chapter3 #fowtr-article14 .chart-selector .selector6').data('powertip', 'Planning & Strategy').powerTip();
      }



      // ---------------------
      // glider slider version
      // ---------------------



      // var sliderContainer = $('#fowtr-chapter3 #fowtr-article11 .glider-contain');
      // var slider = $('#fowtr-chapter3 #fowtr-article11 .glider-contain .glider');
      // var dots = $('#fowtr-chapter3 #fowtr-article11 .glider-contain .dots');
      // var prev = $('#fowtr-chapter3 #fowtr-article11 .slider-prev');
      // var next = $('#fowtr-chapter3 #fowtr-article11 .slider-next');

      // slider.on('glider-slide-visible', function(event) {
      //   console.log('slide in view:',event.detail.slide);
      //   $('#fowtr-chapter3 #fowtr-article11 .chart-selector .selector').removeClass('active');
      //   $('#fowtr-chapter3 #fowtr-article11 .chart-selector .selector[data-slide-index="'+event.detail.slide+'"]').addClass('active');
      // });
      // var glider = new Glider(slider[0], {
      //   slidesToShow: 1,
      //   // dots: dots[0],
      //   // draggable: true,
      //   // dragVelocity: 1,
      //   scrollLock: true,
      //   scrollLockDelay: 0,
      //   arrows: {
      //     prev: prev[0],//'.glider-prev',
      //     next: next[0],//'.glider-next'
      //   }
      // });

      // $('#fowtr-chapter3 #fowtr-article11 .chart-selector').on('click', '.selector', function(event) {
      //   event.preventDefault();
      //   var index = $(this).attr('data-slide-index');
      //   $('#fowtr-chapter3 #fowtr-article11 .chart-selector .selector').removeClass('active');
      //   $(this).addClass('active');
      //   console.log('sliding to:',index);
      //   glider.scrollItem(index,true);
      // });


      // $('#fowtr-chapter3 #fowtr-article11').on('click', '.slider-prev, .slider-next', function(event) {
      //   event.preventDefault();
      // });




      // ---------------------
      // swiffy slider version
      // ---------------------

      // swiffyslider.initSlider($("#fowtr-chapter3 #fowtr-article11 .swiffy-slider")[0]);

      



      // ---------------------
      // tiny slider version
      // ---------------------

      fowtr_module_chapter_3.slider = tns({
        container: '#fowtr-chapter3 #fowtr-article14 .fowtr-slider',
        items: 1,
        controls: false,
        nav: false,
        autoHeight: true,
      });

      // previous button
      $('#fowtr-chapter3 #fowtr-article14').on('click', '.slider-prev', function(event) {
        event.preventDefault();
        fowtr_module_chapter_3.slider.goTo('prev');
        jumpToTop();
      });

      // next button
      $('#fowtr-chapter3 #fowtr-article14').on('click', '.slider-next', function(event) {
        event.preventDefault();
        fowtr_module_chapter_3.slider.goTo('next');
        jumpToTop();
      });

      // click selector icon, go to slide
      $('#fowtr-chapter3 #fowtr-article14 .chart-selector').on('click', '.selector', function(event) {
        event.preventDefault();
        var index = $(this).attr('data-slide-index');
        $('#fowtr-chapter3 #fowtr-article14 .chart-selector .selector').removeClass('active');
        $(this).addClass('active');
        fowtr_module_chapter_3.slider.goTo(index);
        jumpToTop();
      });

      // update icon active on slider change
      fowtr_module_chapter_3.slider.events.on('indexChanged', function(info, eventName) {
        $('#fowtr-chapter3 #fowtr-article14 .chart-selector .selector').removeClass('active');
        $('#fowtr-chapter3 #fowtr-article14 .chart-selector .selector[data-slide-index="'+(info.index-1)+'"]').addClass('active');
      });





      // pinning

      var articleHeight = $('#fowtr-chapter3 #fowtr-article14').height();
      // pinning the section
      var sixSegmentsSelector = new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article14 .chart-selector-wrapper", triggerHook:'onLeave'})
        .setPin("#fowtr-chapter3 #fowtr-article14 .chart-selector-wrapper")
        .on('update', function () {
          // ugly hack to detect if its full header, minimal header, fullscreen etc.
          if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')) {
            sixSegmentsSelector.offset(-50 -50);
          } else {
            if($(window).width()<768){
              sixSegmentsSelector.offset(-56 - 50 -50);
            } else {
              sixSegmentsSelector.offset(-108 - 50 -50);
            }
          }
        })
        .setClassToggle("#fowtr-chapter3 #fowtr-article14 .chart-selector-wrapper", 'pinned')
        .addTo(fowtr_module_chapter_3.controller);


      // var sixSegmentsSelectorUnpin = new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article14", triggerHook:'onEnter', offset: articleHeight})
      //     .setPin("#fowtr-chapter3 #fowtr-article14 .chart-selector-wrapper", { pushFollowers: false })
      //         .addTo(fowtr_module_chapter_3.controller);



      // var articleBottomOffset;
      // if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')) {
      //   articleBottomOffset = (-50);
      // } else {
      //   if($(window).width()<768){
      //     articleBottomOffset = (-56 - 50);
      //   } else {
      //     articleBottomOffset = (-56 - 52 - 50);
      //   }
      // }

      // offset: articleHeight + articleBottomOffset

      var tl5 = new TimelineMax();

      tl5.to("#fowtr-chapter3 #fowtr-article14 .chart-selector-wrapper", 1, {autoAlpha:0, display:'none', ease: Linear.easeNone}, 0);

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter3 #fowtr-article14", triggerHook:'onLeave', duration: 100, offset: articleHeight - 450})
        .setTween(tl5)
        .addTo(fowtr_module_chapter_3.controller);



      // //  hide them as you press, so they show after transition instead of before
      // sliderContainer.on('click', '.glider-prev', function(event) {
      //   if($(this).hasClass('disabled')) return;
      //   $('#fowtr-chapter3 #fowtr-article14 .chart-selector .selector').removeClass('active');
      // });
      // sliderContainer.on('click', '.glider-next', function(event) {
      //   if($(this).hasClass('disabled')) return;
      //   $('#fowtr-chapter3 #fowtr-article14 .chart-selector .selector').removeClass('active');
      // });





      function jumpToTop(){
        var articleRect = $("#fowtr-chapter3 #fowtr-article14")[0].getBoundingClientRect();
        if($("#fowtr-chapter3 #fowtr-article14 .chart-selector-wrapper").hasClass('pinned')) {
        // if(articleRect.top < 0) {
          var offset = $("#fowtr-chapter3 #fowtr-article14").offset();
          TweenMax.to($('html, body'),0.3,{scrollTop:offset.top,ease:Power2.easeInOut});
        }
      }

      // ====================================================================
      // Make arrows fit center on page within a div even if half off screen
      // ====================================================================

      fowtr_module_chapter_3.fitSliderNav = function(){
        var article = $("#fowtr-chapter3 #fowtr-article14");
        var buttons = $("#fowtr-chapter3 #fowtr-article14 .slider-navigation");
        var articleRect = article[0].getBoundingClientRect();
        var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        var windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        var offTop = articleRect.top;
        var offBottom = windowHeight - (articleRect.top + articleRect.height);
        var articleHeight = article.height();

        // exit if not in screen at all
        if((articleRect.top) > windowHeight) return;
        if((articleRect.top + articleHeight) < 0) return;

        // console.log('sticky slider nav');
        // console.log('articleRect',articleRect);

        // console.log('top',offTop);
        // console.log('bottom',offBottom);
        // var availableHeight =  offBottom - offTop;

        var headerHeight = 119 + 52 + 50;
        if(windowWidth < 768){
          headerHeight = 56 + 50;
        }

        headerHeight = 50;

        // buttons.removeClass('hidden');

        var availableHeight =  articleHeight;
        var top = 0;


        if(offTop < 0) {
          availableHeight -= Math.abs(offTop);
          top += Math.abs(offTop);
        }
        if(offBottom < 0) {
          availableHeight -= Math.abs(offBottom);
        }

        // allow for header
        availableHeight -= headerHeight;
        top += headerHeight;

        if(offTop + articleHeight > 200){
          buttons.height(availableHeight+'px');
          buttons.css('top',top+'px');
        }



        // fit selectors
        var headerRect = $('#fowtr-navigation')[0].getBoundingClientRect();
        var headerHeight = headerRect.top + headerRect.height;
        // console.log(headerHeight);
      };




      // $(window).scroll(function(e){
      //   fitSliderNav();
      // });
      // $(window).on('resize', function(){
      //   fitSliderNav();
      // });


      if(!fowtr_module_utilities.disableFancyStuff) {
        document.addEventListener('scroll', fowtr_module_chapter_3.fitSliderNav);
        document.addEventListener('resize', fowtr_module_chapter_3.fitSliderNav);
      } else {
        $("#fowtr-chapter3 #fowtr-article14 .slider-navigation").height($("#fowtr-chapter3 #fowtr-article14").height());
      }

      // END ARTICLE 11 ! :-o














      // survey / Usabilla



      // set up as a SPA
      // window.usabilla_live('virtualPageView');

      // // button handler
      // $('#fowtr-chapter3 #fowtr-article19 .fowtr-survey').click(function(event) {
      //   event.preventDefault();
      //   try {
      //     window.usabilla_live('trigger', 'fow_survey_trigger');
      //     $(this).addClass('disabled');
      //   } catch(e) {
      //     console.warn('usabilla_live not found');
      //   }
      // });

      // // event callback
      // try {
      //   resetUsabilla();
      //   window.usabilla_live('setEventCallback', function(category, action, label, value, userData){
      //     console.log('setEventCallback',action);
      //     if(action === "Campaign:Success" || action === "Campaign:Close") {
      //       resetUsabilla();
      //     }
      //   });
      // } catch(e) {
      //   console.warn('usabilla_live not found');
      // }


      // // usbl.b2d2adfa16cf.c.d5cf372bcc76


      // function resetUsabilla(){
      //   try {
      //     var arr = [];
      //     for (var i = 0; i < localStorage.length; i++){
      //       if (localStorage.key(i).substring(0,18) == 'usbl.b2d2adfa16cf.') {
      //         arr.push(localStorage.key(i));
      //       }
      //     }
      //     for (var i = 0; i < arr.length; i++) {
      //       localStorage.removeItem(arr[i]);
      //     }
      //   } catch(e) {
      //     console.warn('usabilla_live not found');
      //   }
      // }


      // // $(window).unload(function() {
      // //   resetUsabilla();
      // // });
      // resetUsabilla();
      // $(window).on('beforeunload', function(){
      //   resetUsabilla();
      // });








      // // PUT SECTION ID MARKERS ON ALL ARTICLES
      // // $.each($('#fowtr-chapter4 article > div'), function(index, val) {
      // $.each($('#fowtr-chapter3 article > div[id^="fowtr-article"], #fowtr-chapter3 article .scrollmagic-pin-spacer > div[id^="fowtr-article"]'), function(index, val) {
      //    var id = $(this).attr('id');
      //    if(id){
      //     id = id.replace('fowtr-article','');
      //     console.log('article',id);
      //     var marker = $('<div style="background:magenta;color:white;position: absolute;top: 50%;left: 0;transform: rotate(-90deg);transform-origin: top left;padding: 10px;">Section <strong>'+id+'</strong></div>');
      //     $('#fowtr-article'+id).append(marker);
      //    }
      // });






    };//end init function






    fowtr_module_chapter_3.destroy = function(chapter){
      
      console.log('destroy chapter '+chapter);
      document.removeEventListener('scroll', fowtr_module_chapter_3.fitSliderNav);
      document.removeEventListener('resize', fowtr_module_chapter_3.fitSliderNav);

    };//end destroy function





    return fowtr_module_chapter_3;
}(fowtr_module_chapter_3 || {}));

